import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './aboutus.css';
const AboutUsAdmin = () => {
    const [aboutUsContent, setAboutUsContent] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const token = sessionStorage.getItem('authToken'); // Retrieve token from storage

    useEffect(() => {
        fetchAboutUsContent();
    }, []);

    const fetchAboutUsContent = async () => {
        setLoading(true);
        try {
            const response = await axios.get('https://zoomautos.co.uk/api/about-us', {
                
            });
            setAboutUsContent(response.data.content || '');
        } catch (error) {
            setMessage('Failed to fetch content.');
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        setAboutUsContent(e.target.value);
    };

    const handleSave = async () => {
        if (!aboutUsContent.trim()) {
            setMessage('Content cannot be empty.');
            return;
        }

        setLoading(true);
        try {
            const response = await axios.put(
                'https://zoomautos.co.uk/api/about-us/update',
                { content: aboutUsContent },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                setMessage('Content updated successfully.');
            } else {
                setMessage('Failed to update content.');
            }
        } catch (error) {
            setMessage(error.response?.data?.message || 'Error updating content.');
        } finally {
            setLoading(false);
        }
    };

    return (
        
        <div className='aboutusform' style={{margin:'auto', marginTop:'150px', marginBottom:'20px'}}>    
            <h2>Update About Us</h2>
            {loading && <p>Loading...</p>}
            {message && <p style={{ color: message.includes('success') ? 'green' : 'red' }}>{message}</p>}

            <textarea
                style={{
                    width: '100%',
                    height: '200px',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                    marginBottom: '20px',
                }}
                value={aboutUsContent}
                onChange={handleInputChange}
                placeholder="Edit About Us content here..."
            />

            <button
                style={{
                    padding: '10px 20px',
                    backgroundColor: '#007BFF',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                }}
                onClick={handleSave}
                disabled={loading}
            >
                {loading ? 'Saving...' : 'Save Changes'}
            </button>
        </div>
    );
};

export default AboutUsAdmin;
